import removePrecedingSlash from '@helpers/remove-preceding-slash'
import removeTrailingSlash from '@helpers/remove-trailing-slash'

const removeBothEndSlashes = str =>
  removePrecedingSlash(removeTrailingSlash(str))

export default removeBothEndSlashes
